const xylemStorage = {
	applicationDetail: {
		storageName: "applicationDetail",
		// A listing of selectors that will trigger a session storage on an application detail page
		triggerSelectors: ['.application-detail-page div[data-tab-name="products"] a'],

		unTriggerSelectors: ["header a"],
	},

	getCurrentSessionStorage: function (whichStore) {
		try {
			// Ensure store is set up if new
			if (typeof window.sessionStorage[whichStore] === "undefined") {
				window.sessionStorage[whichStore] = "[]";
			}
			return JSON.parse(window.sessionStorage[whichStore]);
		} catch (e) {
			return e;
		}
	},
	setCurrentSessionStorage: function (whichStore, data) {
		window.sessionStorage[whichStore] = JSON.stringify(data);
	},
};

export { xylemStorage };
